'use strict';

module.exports = function (val, message) {
  if (!val) {
    throw new Error(message);
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/auth/need.js
// module id = 64
// module chunks = 0